import { takeLatest, put } from 'redux-saga/effects';

import cmf from '@talend/react-cmf';

import { logout } from '../utils/routing';

const HTTP_STATUS = cmf.middlewares.http.constants.HTTP_STATUS;

function* handleError(event: any) {
	if (!event.error || !event.error.stack) {
		return;
	}
	switch (event.error.stack.status) {
		case HTTP_STATUS.UNAUTHORIZED:
			logout();
			break;
		case HTTP_STATUS.FORBIDDEN:
		case HTTP_STATUS.NOT_FOUND:
			yield put({
				type: '@@router/CALL_HISTORY_METHOD',
				payload: {
					method: 'replace',
					args: [`/${event.error.stack.status}`],
				},
			});
			break;
		default:
	}
}

export function* httpHandler() {
	yield takeLatest('@@HTTP/ERRORS', handleError);
}
